"use client";
import React, { useState } from "react";
import { Sidebar, SidebarBody, SidebarLink } from "../ui/sidebar";
import Link from "next/link";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { BookCopy, ClipboardCheckIcon, LayoutDashboardIcon, LogOutIcon, Settings, Target, UserIcon, WorkflowIcon } from "lucide-react";
import { UserButton, useUser } from "@clerk/nextjs";
import { usePathname } from "next/navigation";
import Menu from "./ui/menu";

export function SidebarApp({ children }: { children: React.ReactNode }) {


  let pathname =usePathname();

  if (pathname === "/") {
    return <>{children}</>;
  }
  const user = useUser().user;
  const links = [
    {
      label: "Dashboard",
      href: "/dashboard",
      icon: (
        <LayoutDashboardIcon className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />
      ),
    },
    {
      label: "Projects",
      href: "/dashboard/projects",
      icon: (
        <Target className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />
      ),
    },
    {
      label: "Spaces",
      href: "/dashboard/spaces",
      icon: (
        <UserIcon className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />
      ),
    },
    {
      label: "Jobs",
      href: "/dashboard/jobs",
      icon: (
        <ClipboardCheckIcon className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />
      ),
    },
    {
      label: "Settings",
      href: "#",
      icon: (
        // make warning color
        <Settings className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />
      ),
    },
    {
      label: "",
      href: "#",
      icon: (
        <Menu  />
      ),
    },
  ];
  const [open, setOpen] = useState(false);

  return (
    <div
      className={cn(
        "rounded-md flex flex-col md:flex-row w-full flex-1 overflow-hidden",
        "h-screen" // Full height
      )}
    >
      {/* Sidebar with no background */}
      <Sidebar open={open}
      
       setOpen={setOpen} >
        <SidebarBody className="justify-between gap-10">
          <div className="flex flex-col flex-1  m-3">
            {open ? <Logo /> : <LogoIcon />}
            <div className="mt-8 flex flex-col gap-2">
              {links.map((link, idx) => (
                <SidebarLink key={idx} link={link} />
              ))}
            </div>
         
          </div>

          {/* Styled UserButton */}
          
          <div className="flex items-center justify-center p-4">
            
            <UserButton
            
              appearance={{
            
                elements: {
                  userButtonAvatarBox: "h-10 w-10", // Adjust avatar size
                  userButtonPopoverCard: "bg-white dark:bg-black", // Customize popover background
                },
              }}
            />
          </div>
        </SidebarBody>
      </Sidebar>
      <div 
      className="flex-1 overflow-y-auto p-4"
      >
      {children}
      </div>
    </div>
  );
}

export const Logo = () => {
  return (
    <Link
      href="#"
      className="font-normal flex space-x-2 items-center text-sm text-black py-1 relative z-20"
    >
      <div className="h-5 w-6 bg-black dark:bg-white rounded-br-lg rounded-tr-sm rounded-tl-lg rounded-bl-sm flex-shrink-0" />
      <motion.span
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="font-medium text-black dark:text-white whitespace-pre"
      >
        DOCLOO
      </motion.span>
    </Link>
  );
};

export const LogoIcon = () => {
  return (
    <Link
      href="#"
      className="font-normal flex space-x-2 items-center text-sm text-black py-1 relative z-20"
    >
      <div className="h-5 w-6 bg-black dark:bg-white rounded-br-lg rounded-tr-sm rounded-tl-lg rounded-bl-sm flex-shrink-0" />
    </Link>
  );
};